<template>
  <b-container class="commissions-management" fluid>
    <page-title icon="fas fa-cogs">
      <translate>Custom Commissions</translate>
    </page-title>
    <b-card>
      <b-row>
        <b-col>
          <label for="filter" v-translate>Filter users as you type</label>
          <b-form-input class="w-10" v-model="filter" type="search" :placeholder="$gettext('By name or email')" />
        </b-col>
      </b-row>
    </b-card>
    <b-row>
      <b-col>
        <div class="my-3" v-translate="{results: filteredUsers.length}">
          Results: <strong>%{results}</strong>
        </div>
      </b-col>
    </b-row>
    <b-row>
      <b-col sm="6" lg="4" xl="3" v-for="(user, index) in filteredUsers" :key="index">
        <b-card class="text-center" :class="!user.active ? 'text-muted': ''">
          <small v-show="user.roles.some(y => y.name === 'gcm-admin')" class="bg-dark text-light" style="position:absolute; top: 0; left: 0; padding:3px;"><font-awesome-icon icon="user-cog" size="1x" /> ADMIN</small>
          <small v-show="user.roles.some(y => y.name === 'courier')" class="bg-info text-light" style="position:absolute; top: 0; right: 0; padding:3px;" v-translate>Courier</small>
          <img src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAQAAAC1HAwCAAAAC0lEQVR42mNkYAAAAAYAAjCB0C8AAAAASUVORK5CYII=" class="mb-3 rounded-circle profile-image" alt="img" :style="'width: 80px; height: 80px; background-image: url(' + (user.profile_picture || 'https://www.gravatar.com/avatar/default?s=80&r=pg&d=mm') + ')'" />
          <b-card-title class="mb-2">{{user.name}}</b-card-title>
          <b-card-text>
            <div class="mb-3">{{user.email}}</div>
            <in-app-commission-form :user="user" @done="fetchUsers" v-if="user.active" />
          </b-card-text>
        </b-card>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
import cloneDeep from 'lodash/cloneDeep'
import InAppCommissionForm from '@/components/InAppCommissionFormFix'

export default {
  name: 'ConfigCommissions',
  title() {
    return this.$gettext('Custom Commissions')
  },
  components: {
    InAppCommissionForm
  },
  data() {
    return {
      users: [],
      filter: '',
      filteredUsers: []
    }
  },
  computed: {
    oneAdminOnly() {
      return this.users.filter(x => x.roles.some(y => y.name === 'gcm-admin')).length === 1
    },
    hasCompany() {
      return this.$store.getters.profile && this.$store.getters.profile.company_id !== null
    },
    isGcmAdmin() {
      return this.hasCompany && this.$store.getters.profile.company && this.$store.getters.profile.roles.some(x => x.name === 'gcm-admin')
    }
  },
  watch: {
    filter(val) {
      this.filteredUsers = this.users.filter(x => x.name.toLowerCase().includes(val.toLowerCase()) || x.email.toLowerCase().includes(val.toLowerCase()))
    }
  },
  mounted() {
    this.fetchUsers()
  },
  methods: {
    fetchUsers() {
      this.$store.dispatch('fetchProfile')
        .then(() => {
          this.users = this.profile.company.users.filter(x => x.active === 1)
          this.filteredUsers = cloneDeep(this.users)
        })
    }
  }
}
</script>
